// src/components/FilterBar.tsx or a separate constants file

export const ALL_PLATFORMS = ["instagram", "tiktok", "telegram"];
